export const ui = {
  seo: {
    title: {
      en: 'PA Concreto & Asphalt | Professional Concrete & Asphalt Services',
      es: 'PA Concreto & Asphalt | Servicios Profesionales de Concreto y Asfalto',
    },
    description: {
      en: 'Professional concrete and asphalt services. Expert construction work for residential and commercial projects. Free estimates available.',
      es: 'Servicios profesionales de concreto y asfalto. Trabajo experto para proyectos residenciales y comerciales. Estimados gratis.',
    },
  },
  common: {
    language: { en: 'Language', es: 'Idioma' },
    menuOpen: { en: 'Open menu', es: 'Abrir menú' },
    menuClose: { en: 'Close menu', es: 'Cerrar menú' },
    home: { en: 'home', es: 'inicio' },
  },
  cta: {
    estimate: { en: 'Get Free Estimate', es: 'Estimado Gratis' },
    estimateShort: { en: 'Free Estimate', es: 'Estimado Gratis' },
    callNow: { en: 'Call Now', es: 'Llamar Ahora' },
    contactUs: { en: 'Contact Us', es: 'Contáctanos' },
  },
  hero: {
    titleBefore: { en: 'Professional Concrete & ', es: 'Servicios Profesionales de Concreto y ' },
    titleHighlight: { en: 'Asphalt', es: 'Asfalto' },
    titleAfter: { en: ' Services', es: '' },
    subtitle: {
      en: 'Quality construction work for residential and commercial projects. Professional service you can trust.',
      es: 'Trabajo de construcción de calidad para proyectos residenciales y comerciales. Un servicio profesional en el que puedes confiar.',
    },
    serving: { en: 'Serving', es: 'Sirviendo a' },
    freeNote: { en: 'Free, no-obligation estimates', es: 'Estimados gratis y sin compromiso' },
    imageAlt: {
      en: 'PA Concreto & Asphalt crew pouring concrete beside a fresh asphalt paving job',
      es: 'Equipo de PA Concreto & Asphalt vaciando concreto junto a una pavimentación de asfalto',
    },
  },
  services: {
    title: { en: 'Concrete and asphalt, done right the first time', es: 'Concreto y asfalto, bien hecho desde la primera vez' },
    subtitle: {
      en: 'Residential driveways to commercial lots — one crew handles the pour, the pave, and the upkeep.',
      es: 'De entradas residenciales a estacionamientos comerciales: un solo equipo se encarga del vaciado, el pavimento y el mantenimiento.',
    },
    includes: { en: 'includes', es: 'incluye' },
  },
  process: {
    title: { en: 'Our Process', es: 'Nuestro Proceso' },
    subtitle: { en: 'Simple, transparent, professional', es: 'Simple, transparente, profesional' },
  },
  testimonials: {
    title: { en: 'What Our Clients Say', es: 'Qué Dicen Nuestros Clientes' },
    subtitle: { en: 'Real projects, real results, real satisfaction', es: 'Proyectos reales, resultados reales, satisfacción real' },
    rating: { en: '5 out of 5 stars', es: '5 de 5 estrellas' },
  },
  gallery: {
    title: { en: 'Project Gallery', es: 'Galería de Proyectos' },
    subtitle: { en: 'See the transformation we deliver', es: 'Mira la transformación que entregamos' },
    before: { en: 'Before', es: 'Antes' },
    after: { en: 'After', es: 'Después' },
    drag: { en: 'Drag to compare before and after', es: 'Desliza para comparar antes y después' },
    expand: { en: 'View full size', es: 'Ver en grande' },
    close: { en: 'Close', es: 'Cerrar' },
  },
  whyUs: {
    title: { en: 'Why Choose PA Concreto & Asphalt', es: 'Por Qué Elegir PA Concreto & Asphalt' },
    subtitle: { en: 'Trusted by hundreds of satisfied clients', es: 'Con la confianza de cientos de clientes satisfechos' },
  },
  faq: {
    title: { en: 'Frequently Asked Questions', es: 'Preguntas Frecuentes' },
    subtitle: { en: 'Get answers to common questions', es: 'Respuestas a las preguntas más comunes' },
    stillQuestions: { en: 'Still have a question?', es: '¿Tienes otra pregunta?' },
    callUs: { en: 'Call Pablo and get a straight answer.', es: 'Llama a Pablo y recibe una respuesta directa.' },
  },
  areas: {
    title: { en: 'We Serve Your Area', es: 'Servimos Tu Área' },
    subtitle: { en: 'Proudly serving Chicagoland and surrounding suburbs', es: 'Orgullosamente sirviendo Chicagoland y suburbios cercanos' },
    cta: { en: "Don't see your area? Contact us to confirm coverage.", es: '¿No ves tu área? Contáctanos para confirmar cobertura.' },
  },
  contact: {
    title: { en: 'Get your free estimate', es: 'Obtén tu estimado gratis' },
    subtitle: {
      en: "Contact us for a free, no-obligation estimate on your project. We're ready to discuss your construction needs.",
      es: 'Contáctanos para un estimado gratuito y sin compromiso. Estamos listos para hablar de tu proyecto.',
    },
    callDirect: { en: 'Call Pablo directly', es: 'Llama a Pablo directamente' },
    hours: { en: 'Hours', es: 'Horario' },
    area: { en: 'Service area', es: 'Área de servicio' },
  },
  form: {
    title: { en: 'Request a free estimate', es: 'Solicita un estimado gratis' },
    subtitle: { en: 'We usually respond within one business day.', es: 'Normalmente respondemos en un día hábil.' },
    name: { en: 'Full name', es: 'Nombre completo' },
    email: { en: 'Email', es: 'Correo electrónico' },
    phone: { en: 'Phone number', es: 'Teléfono' },
    service: { en: 'Service type', es: 'Tipo de servicio' },
    description: { en: 'Project description', es: 'Descripción del proyecto' },
    descriptionPlaceholder: {
      en: 'e.g. Replace a 2-car driveway, approx. 20 × 40 ft',
      es: 'ej. Reemplazar una entrada para 2 autos, aprox. 20 × 40 pies',
    },
    method: { en: 'Preferred contact method', es: 'Método de contacto preferido' },
    methodPhone: { en: 'Phone', es: 'Teléfono' },
    methodEmail: { en: 'Email', es: 'Correo' },
    submit: { en: 'Request Free Estimate', es: 'Solicitar Estimado Gratis' },
    sending: { en: 'Sending…', es: 'Enviando…' },
    successTitle: { en: 'Request received', es: 'Solicitud recibida' },
    successBody: {
      en: "Thank you! We'll contact you shortly with your estimate.",
      es: '¡Gracias! Te contactaremos pronto con tu estimado.',
    },
    another: { en: 'Submit another request', es: 'Enviar otra solicitud' },
    error: {
      en: 'Something went wrong. Please try again or call us directly.',
      es: 'Algo salió mal. Inténtalo de nuevo o llámanos directamente.',
    },
    errors: {
      nameRequired: { en: 'Please enter your full name.', es: 'Por favor ingresa tu nombre completo.' },
      emailRequired: { en: 'Please enter your email.', es: 'Por favor ingresa tu correo.' },
      emailInvalid: { en: 'Please enter a valid email.', es: 'Por favor ingresa un correo válido.' },
      phoneRequired: { en: 'Please enter your phone number.', es: 'Por favor ingresa tu teléfono.' },
      phoneInvalid: { en: 'Please enter a valid phone number.', es: 'Por favor ingresa un teléfono válido.' },
    },
  },
  footer: {
    tagline: {
      en: 'Professional concrete and asphalt construction services for residential and commercial projects.',
      es: 'Servicios profesionales de concreto y asfalto para proyectos residenciales y comerciales.',
    },
    quickLinks: { en: 'Quick links', es: 'Enlaces rápidos' },
    contact: { en: 'Contact', es: 'Contacto' },
    rights: { en: 'All rights reserved.', es: 'Todos los derechos reservados.' },
  },
};

export type FormErrorKey = keyof typeof ui.form.errors;
